<ng-template #cdtHeaderTemplate>
  <fa-icon icon="calendar-alt" size="2x" class="text-primary transparent-3"></fa-icon>
</ng-template>
<ng-template #cdtTemplateContent>
  <div class="cdt-content p-3 d-flex flex-column">
    <div class="mb-4">
      <div class="fw-bold">{{ prestations.length }} prestation(s) planifiée(s)</div>
      <div>
        ces 4 prochains mois
      </div>

    </div>
    <a routerLink="prestations" class="align-self-end">Consulter le calendrier</a>
  </div>
</ng-template>
<app-dash-block title="Prestations planifiées" [headerTemplate]="cdtHeaderTemplate"
                [contentTemplate]="prestations ? cdtTemplateContent : null">
</app-dash-block>
